import { exchangeCodeForTokens } from "@/lib/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallbackPage,
});

function AuthCallbackPage() {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const codeVerifier = sessionStorage.getItem("code_verifier");

      if (!code || !codeVerifier) {
        setError("認証パラメータが不足しています");
        return;
      }

      try {
        await exchangeCodeForTokens(code, codeVerifier);
        sessionStorage.removeItem("code_verifier");
        navigate({ to: "/" });
      } catch {
        setError("認証に失敗しました");
      }
    };
    handleCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-4">
        <p className="text-destructive">{error}</p>
        <a href="/" className="text-primary underline">
          トップに戻る
        </a>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-muted-foreground">認証中...</p>
    </div>
  );
}
